import {extend} from 'flarum/extend';
import DiscussionControls from 'flarum/utils/DiscussionControls';

export default function () {
  extend(DiscussionControls, 'destructiveControls', function (items) {
    if (items.has("hide")) {
      items.get("hide").attrs.icon = "fas fa-hourglass-half";
    }
  });

}
